"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const classnames_1 = __importDefault(require("classnames"));
const Link = ({ children, to, className, onClick, activeStyle, matchSearchParams, style, }) => {
    const location = (0, react_router_dom_1.useLocation)();
    return (react_1.default.createElement(react_router_dom_1.NavLink, { to: to, style: style, className: ({ isActive }) => {
            const active = activeStyle != null
                ? activeStyle
                : matchSearchParams
                    ? to === location.pathname + location.search
                    : isActive;
            return (0, classnames_1.default)(className != null ? className : "navbar-item", active && "is-active");
        }, onClick: onClick, end: true }, children));
};
exports.default = Link;
